class UtilsHolder {

    set (name, utilsInstance) {
        this[name] = utilsInstance;
    }

    get (name) {
        return this[name];
    }
}

const utilsHolder = new UtilsHolder();

export default utilsHolder;
